import TechSectionHeader from "./TechSectionHeader";
import TechStackGrid from "./TechStackGrid";

import {
    aiTech,
    analyticsTech,
    cmsTech,
    testingTech,
} from "./technologies.data";

export default function TechQualityAndGrowth() {
    const allQualityGrowthTech = [
      ...testingTech,
      ...cmsTech,
      ...analyticsTech,
      ...aiTech,
    ];
  return (
    <>
      <section className="tech-section">
        <TechSectionHeader
          eyebrow="QUALITY & GROWTH"
          title="Testing, Analytics &"
          highlight="Product Intelligence"
          subtitle="Tools and platforms that ensure product quality, insights, automation, and long-term growth."
        />
        <TechStackGrid items={allQualityGrowthTech} />
      </section>
    </>
  );
}
